import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Box,
  Avatar,
  Divider,
  Tooltip,
  IconButton,
  Link,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogActions,
  FormControl,
  FormHelperText,
} from "@mui/material";
import {
  CalendarToday,
  Assignment,
  Group,
  Info,
  ArrowBack,
  InsertDriveFile,
} from "@mui/icons-material";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { BASE_URL, postData } from "../../../Utils/Baseurl";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialTypography from "../../../../components/MaterialTypography";
import { useLoading } from "../../../../context/loadingcontext";
import { useSnackbar } from "../../../../components/SnackbarProvider";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialSelect from "../../../../components/MaterialSelect";

const MomView = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const location = useLocation();
  const data = location?.state?.data?.allData;
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const [taskState, settaskState] = useState({
    hours: "",
    comment: "",
    progresstatus: "",
    hoursStatus: "unchecked",
    commentStatus: "unchecked",
    progresstatusStatus: "unchecked",
  });

  let progressOptions = [
    { label: "In Progress", value: "In Progress" },
    { label: "Completed", value: "Completed" },
    { label: "Hold", value: "Hold" },
    { label: "Abort", value: "Abort" },
  ];

  useEffect(() => {
    settaskState({
      ...taskState,
      hours: "",
      comment: "",
      hoursStatus: "unchecked",
      commentStatus: "unchecked",
    });
  }, [taskState.progresstatus]);

  const renderAttachment = (url) => {
    const fileName = url?.split("/").pop();
    const extension = fileName?.split(".").pop()?.toLowerCase();
    if (!extension) return null;

    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(extension);
    const isPDF = extension === "pdf";
    const isWord = ["doc", "docx"].includes(extension);

    if (isImage) {
      return (
        <Box mt={1}>
          <img
            src={url}
            alt="Attachment"
            style={{
              maxWidth: 300,
              height: "auto",
              borderRadius: 6,
              boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
            }}
          />
        </Box>
      );
    }

    if (isPDF) {
      return (
        <Box mt={1}>
          <iframe
            src={url}
            title="PDF Attachment"
            width="100%"
            height="400px"
            style={{ border: "none", borderRadius: 6 }}
          />
        </Box>
      );
    }

    const label = isWord ? "View Word Document" : "Download Attachment";
    return (
      <Box mt={1}>
        <Link
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          <Chip
            icon={<InsertDriveFile />}
            label={label}
            color={isWord ? "primary" : "secondary"}
            clickable
            size="small"
          />
        </Link>
      </Box>
    );
  };

  // added by dhanasekar
  const handlechangepopup = (eventOrValue, meta) => {
    if (meta?.name === "status") {
      const value = eventOrValue?.value || "";
      settaskState((prev) => ({
        ...prev,
        progresstatus: eventOrValue,
        progresstatusStatus: value ? "success" : "error",
      }));
      return;
    }

    const { name, value } = eventOrValue.target;

    if (name === "hours") {
      const isValid = value !== "" && !isNaN(value) && Number(value) > 0;
      settaskState((prev) => ({
        ...prev,
        hours: value,
        hoursStatus: isValid ? "success" : "error",
      }));
    }

    if (name === "comment") {
      const isValid = value.trim().length >= 1 && value.trim().length <= 250;
      settaskState((prev) => ({
        ...prev,
        comment: value,
        commentStatus: isValid ? "success" : "error",
      }));
    }
  };
  const InfoChip = ({ label, value, icon }) => (
    <Box display="flex" alignItems="center" gap={1} mb={1}>
      {icon}
      <Typography variant="body2" fontWeight={500} width="fit-content">
        {label}:
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {value || "N/A"}
      </Typography>
    </Box>
  );

  const renderStatusAction = (status, show) => {
    if (!status) return null;

    if (status === "Completed") {
      return <Chip label="Task Completed" color="success" />;
    }

    const statusLabelMap = {
      "Not Started": "Update Status",
      "In progress": "Update Status",
      Hold: "Update Status",
      Abort: "Update Status",
    };

    const label = statusLabelMap[status];

    if (!label) return null;

    return (
      <MaterialButton
        onClick={() => handleAction(status)}
        sx={{ m: 2 }}
        variant="gradient"
        color="dark"
        disabled={show == null ? true : false}
      >
        {label}
      </MaterialButton>
    );
  };

  const handleAction = (value) => {
    setDialogOpen(true);
  };
  const handleDailogClose = () => {
    setDialogOpen(false);
    reset();
  };

  const reset = () => {
    settaskState({
      ...taskState,
      hours: "",
      comment: "",
      progresstatus: "",
      hoursStatus: "unchecked",
      commentStatus: "unchecked",
      progresstatusStatus: "unchecked",
    });
  };

  const handleSave = async () => {
    setCirleLoading(true);
    let datas = {
      status: taskState.progresstatus?.label,
      actual_hours: taskState.hours,
      comment: taskState.comment,
    };
    try {
      const res = await postData(`api/meetingtaskstatus/${data?.id}/`, datas);
      if (res?.status) {
        showSnackbar(res?.message, "success");
        navigate("/action-items");
        reset();
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      handleDailogClose();
      setCirleLoading(false);
    }
  };

  const isFormValid = () => {
    if (taskState?.progresstatus?.label === "Completed") {
      return (
        taskState.progresstatusStatus === "success" &&
        taskState.hoursStatus === "success"
      );
    } else if (taskState?.progresstatus?.label === "Hold") {
      return (
        taskState.progresstatusStatus === "success" &&
        taskState.commentStatus === "success"
      );
    } else if (taskState?.progresstatus?.label === "Abort") {
      return (
        taskState.progresstatusStatus === "success" &&
        taskState.commentStatus === "success"
      );
    } else {
      return taskState.progresstatusStatus === "success";
    }
  };

  const filteredOptions = (() => {
    if (data?.status === "Not Started") {
      return [{ label: "In Progress", value: "In Progress" }];
    }

    if (data?.status === "In progress") {
      return [
        { label: "Completed", value: "Completed" },
        { label: "Hold", value: "Hold" },
        { label: "Abort", value: "Abort" },
      ];
    }

    return progressOptions; 
  })();

  return (
    <DashboardLayout>
      <Box p={2}>
        <IconButton onClick={() => navigate(-1)} color="primary" size="small">
          <ArrowBack />
        </IconButton>

        <Card elevation={2} sx={{ mt: 2 }}>
          <CardContent>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              📝 Task: {data?.meeting_title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {data?.action_item || "No description provided."}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <InfoChip
                  label="Assignee"
                  value={data?.assignee_name}
                  icon={<Assignment fontSize="small" />}
                />
                <InfoChip
                  label="Task Code"
                  value={data?.task_code}
                  icon={<Assignment fontSize="small" />}
                />
                <InfoChip
                  label="Start Date"
                  value={data?.start_date}
                  icon={<CalendarToday fontSize="small" />}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <InfoChip
                  label="Status"
                  value={
                    <Chip
                      label={data?.status || "Not Updated"}
                      color="primary"
                      size="small"
                      sx={{ fontWeight: 600 }}
                    />
                  }
                  icon={<Info fontSize="small" />}
                />
                <InfoChip
                  label="Project"
                  value={data?.project_name}
                  icon={<Info fontSize="small" />}
                />
                <InfoChip
                  label="End Date"
                  value={data?.end_date}
                  icon={<CalendarToday fontSize="small" />}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InfoChip
                  label="Actual Start Date"
                  value={data?.actual_start_date}
                  icon={<CalendarToday fontSize="small" />}
                />
                <InfoChip
                  label="Actual End Date"
                  value={data?.actual_end_date}
                  icon={<CalendarToday fontSize="small" />}
                />
              </Grid>

              {/* Column 3 */}
            </Grid>

            {/* Attachment */}
            {data?.attachment && (
              <Box mt={3}>
                <Typography variant="subtitle2" gutterBottom>
                  📎 Attachment
                </Typography>
                {renderAttachment(`${BASE_URL}${data.attachment}`)}
              </Box>
            )}

            {/* Stakeholders */}
            {Array.isArray(data?.stake_holder) && (
              <Box mt={3}>
                <Typography variant="subtitle2" gutterBottom>
                  👥 Stakeholders
                </Typography>
                <Grid container spacing={1}>
                  {data?.stake_holder.map((s, index) => (
                    <Grid item key={index}>
                      <Tooltip title={s.user_name || `User ${index + 1}`}>
                        <Chip
                          avatar={
                            <Avatar sx={{ width: 24, height: 24 }}>
                              {s.user_name?.[0] || "U"}
                            </Avatar>
                          }
                          label={s.user_name || `User ${index + 1}`}
                          variant="outlined"
                          size="small"
                          icon={<Group fontSize="small" />}
                          color="secondary"
                        />
                      </Tooltip>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}

            {/* Status Action */}
            <Box mt={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
              {renderStatusAction(data?.status, data?.assignee)}
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Dialog
        open={dialogOpen}
        onClose={handleDailogClose}
        aria-labelledby="new-employee-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            width: "800px",
            maxWidth: "90%",
            minHeight: "50%",
          },
        }}
      >
        <DialogTitle id="new-employee-dialog-title"></DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Status <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="status"
                value={taskState?.progresstatus}
                customStyles={{ optionPadding: 15 }}
                options={filteredOptions}
                onChange={handlechangepopup}
                isClearable
                error={
                  taskState?.progresstatusStatus === "error" ? true : false
                }
                success={
                  taskState?.progresstatusStatus === "success" ? true : false
                }
              />
            </Grid>
            {taskState?.progresstatus?.label === "Completed" && (
              <Grid size={{ xs: 12, md: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Actual Hours <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={taskState?.hours}
                  type="number"
                  name="hours"
                  placeholder="Enter hours"
                  onChange={handlechangepopup}
                  error={taskState?.hoursStatus === "error" ? true : false}
                  success={taskState?.hoursStatus === "success" ? true : false}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>
            )}
            {(taskState?.progresstatus?.label === "Hold" ||
              taskState?.progresstatus?.label === "Abort") && (
                <Grid size={{ xs: 12, md: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Comments
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    multiline
                    rows={3}
                    value={taskState.comment}
                    name="comment"
                    placeholder="Enter Task description"
                    onChange={handlechangepopup}
                    error={taskState.commentStatus === "error" ? true : false}
                    success={taskState.commentStatus === "success" ? true : false}
                  />
                  {taskState.commentStatus === "error" ? (
                    <FormControl error>
                      <FormHelperText>
                        Comments must be between 1 and 250 letters.{" "}
                      </FormHelperText>
                    </FormControl>
                  ) : null}
                </Grid>
              )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <MaterialButton
            onClick={handleDailogClose}
            color="dark"
            variant="contained"
          >
            Cancel
          </MaterialButton>
          <MaterialButton
            onClick={handleSave}
            color="dark"
            variant="contained"
            disabled={!isFormValid()}
          >
            Save
          </MaterialButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};
export default MomView;
